import { toast } from 'react-toastify';

const defaultOptions = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'light',
};

export const showSuccess = (message, options = {}) =>
  toast.success(message, { ...defaultOptions, className: 'toast-success', progressClassName: 'toast-progress', ...options });

export const showError = (message, options = {}) =>
  toast.error(message, { ...defaultOptions, className: 'toast-error', progressClassName: 'toast-progress', ...options });

export const showInfo = (message, options = {}) =>
  toast.info(message, { ...defaultOptions, className: 'toast-info', progressClassName: 'toast-progress', ...options });

export const showWarning = (message, options = {}) =>
  toast.warn(message, { ...defaultOptions, className: 'toast-warning', progressClassName: 'toast-progress', ...options });

export default { showSuccess, showError, showInfo, showWarning };
